/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ role: NonNullable<unknown>, fields: NonNullable<unknown> }} Perks_Carry_DriftedInputs */



/**
* | output |
* | --- |
* | "Someone changed @{role}'s {fields} in Discord." |
*
* @param {Perks_Carry_DriftedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_carry_drifted = /** @type {((inputs: Perks_Carry_DriftedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Carry_DriftedInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Кто-то изменил ${i?.fields} роли @${i?.role} в Discord.`)
	return /** @type {LocalizedString} */ (`Someone changed @${i?.role}'s ${i?.fields} in Discord.`)
});